/**
 * Program labels from /user/user/program (and similar APIs) already resolve
 * translation on the server. Passing that string through DevExtreme formatMessage
 * (t) can return wrong keys — only run t() when no API translation is present.
 */

export type ProgramLabelItem = {
  programName?: string;
  translation?: string | null;
  autoTranslation?: string | null;
};

function isNonBlank(s: string | null | undefined): boolean {
  return typeof s === 'string' && s.trim().length > 0;
}

export function hasApiProgramTranslation(
  item: ProgramLabelItem | null | undefined,
): boolean {
  if (!item) return false;
  return isNonBlank(item.translation) || isNonBlank(item.autoTranslation);
}

export function programLabelFromApi(
  item: ProgramLabelItem | null | undefined,
  t: (key: string) => string,
): string {
  const name = item?.programName ?? '';
  if (!item || !name) return '';
  if (hasApiProgramTranslation(item)) return name;
  const localized = t(name);
  return localized || name;
}
